import { useEffect } from "react";
import { useNavigate, Outlet, Link, useLocation } from "react-router-dom";
import { getAdminToken, clearAdminToken } from "@/lib/adminApi";
import { securityMonitor } from "@/lib/securityMonitor";
import { Button } from "@/components/ui/button";

const AdminLayout = () => {
  const nav = useNavigate();
  const loc = useLocation();
  useEffect(() => {
    const token = getAdminToken();
    if (!token) {
      securityMonitor.logEvent({
        type: 'auth_attempt',
        severity: 'medium',
        message: 'Unauthorized admin access attempt',
        metadata: { path: loc.pathname, hasToken: false }
      });
      nav("/portal-commodit-7842/login", { replace: true, state: { from: loc.pathname } });
    } else {
      securityMonitor.logDataAccess('admin_portal', 'access', { path: loc.pathname });
    }
  }, [nav, loc.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border/50">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="text-lg font-semibold">Admin Portal</h1>
          <div className="space-x-3">
            <Link to="/" className="text-sm underline">Preview site</Link>
            <Button variant="outline" size="sm" onClick={() => { clearAdminToken(); nav("/portal-commodit-7842/login"); }}>Logout</Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;